var map = {
	"./about.htm": "50dc",
	"./checkoutConditions_ru.htm": "8e7d",
	"./delivery.htm": "079c",
	"./privacypolicy.htm": "dc4f",
	"./sitemap.htm": "1b32",
	"./terms.htm": "efac",
	"./warranty.htm": "5b5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba4c";